import BrightCove from 'brightcove'
import brightcovePlayerLoader from '@brightcove/player-loader';
define( [
  "globals",
  "base-view-model",
  "knockout",
  "underscore",
  "postal",
  "jquery",
  "tappy"],
function ( globals, baseViewModel, ko, _, postal, $ ) {
    // "use strict";

    var ImageModel = function ( urlAddress, id, mediaId, altText, caption, isVideo ) {
        var self = this;
        self.path = urlAddress;
        self.id = id;
        self.mediaId = mediaId;
        self.hidden = ko.observable( false );
        self.altText = altText;
        self.caption = caption;
        self.isVideo = isVideo === undefined ? false : true;
    };

    var ThumbnailModel = function ( urlAddress, id, mediaId, altText, caption, isVideo ) {
        var imageDesktopDimensions = globals.imageDimensions || { width: 400, height: 400 };
        var self = this;
        var channel = postal.channel( "productpage" );
        self.id = id;
        self.mediaId = mediaId;
        self.imageUrl = urlAddress;
        self.path = self.imageUrl + "?quality=90&mode=crop&anchor=middlecenter&width=100&height=100&format=jpg";
        self.imagePath = self.imageUrl + "?quality=90&mode=crop&anchor=middlecenter&width=" + imageDesktopDimensions.width + "&height=" + imageDesktopDimensions.height + "&format=jpg";
        self.imagePathMobile = self.imageUrl + "?quality=90&mode=crop&anchor=middlecenter&width=400&height=250&format=jpg";
        self.imagePathDesktop = self.imageUrl + "?quality=90&mode=crop&anchor=middlecenter&width=" + imageDesktopDimensions.width + "&height=" + imageDesktopDimensions.height + "&format=jpg";
        self.altText = altText;
        self.caption = ko.observable( caption );
        self.requestMainGallery = function () {
            channel.publish( "show.main.gallery", self.id );
        };
        self.isVideo = isVideo === undefined ? false : true;
        self.changeMainImage = function () {
            if ( self.isVideo === true ) {
                return;
            }
            channel.publish( "change.main.image", self );
        };
        self.isSelected = ko.observable( false );
    };

    var ProductGalleryViewModel = function ( data, imageQueryStringParams ) {
        var self = this;
        ko.utils.extend( self, baseViewModel );

        self.maxPreviewGallerySize = 999;
        self.thumbnails = ko.observableArray();
        self.previewThumbnails = ko.observableArray();
        self.images = ko.observableArray();
        self.mainImage = ko.observable();
        self.moreImagesAvailable = data.length > self.maxPreviewGallerySize;
        self.videos = ko.observableArray();
        self.isMobile = globals.ssm.getState( "mobile" ).active;
        self.videoAccountId = globals.brightcove.accountId;
        self.videoPlayerId = globals.brightcove.playerId;
        self.brightCove = new BrightCove();
        self.currGalleryVideoPlayer = {};
        self.hasVideos = ko.computed( function () {
            if ( self.videos().length === 0 ) {
                return false;
            }
            return true;
        } ).extend( {
            notify: 'always'
        } );

        self.viewVideo = function () {
            document.getElementById( 'gcc-product-gallery-type-videos' ).checked = true;
            if ( self.videos().length > 0 ) {
                self.showVideo( self.videos()[0], true );
            }
        }

        self.shouldShowVideosTab = ko.computed( function () {
            if ( globals.ssm.getState( "mobile" ).active ) {
                return false;
            }
            if ( self.hasVideos() ) {
                return true;
            } else {
                return false;
            }
        } );

        var channel = postal.channel( "productpage" );
        self.mainImage = ko.observable( globals.models.mainImage );

        if ( self.mainImage() !== undefined ) {
            self.images.push( new ImageModel( self.mainImage().MediaUrl + '?quality=90&mode=crop&anchor=middlecenter&width=565&height=565&format=jpg', -1, self.mainImage().MediaId, self.mainImage().AltText, self.mainImage().Caption, imageQueryStringParams ) );
        }

        _.each( data, function ( element, index ) {
            if ( index < self.maxPreviewGallerySize ) {
                // Only display the first image in Gallery Preview when we have no Main Image
                if ( index === 0 ) {
                    if ( self.mainImage() === undefined ) {
                        self.images.push( new ImageModel( element.MediaUrl, index, element.MediaId, element.AlternateText, element.Caption, imageQueryStringParams ) );
                    }
                }
                if ( element.PresentationName !== "Main Image" ) {
                    self.thumbnails.push( new ThumbnailModel( element.MediaUrl, index, element.MediaId, element.AlternateText, element.Caption ) );
                    if ( self.previewThumbnails().length < 4 ) {
                        self.previewThumbnails.push( new ThumbnailModel( element.MediaUrl, index, element.MediaId, element.AlternateText, element.Caption ) );
                    }
                }
            }
        } );

        channel.subscribe( "change.main.image", function ( thumbnail ) {
            $( ".bdc-product-slideshow:first" ).slick( "slickGoTo", ( parseInt( thumbnail.id ) ) );
        } );

        self.requestMainGallery = function () {
            channel.publish( "show.main.gallery" );
        };

        // This function is specific to the gallery detail modal.
        self.changeMedia = function ( media ) {
            if (media.isSelected()) return;
            if ( media instanceof ThumbnailModel ) {
                $( ".bdc-current-video-caption" ).hide();
                self.clearCurrentVideo("#bcVideoPlayerWrapper-Modal");
                self.changeImage( media );
            } else {
                $( ".bdc-current-video-caption").show();
                _.each(self.thumbnails(), function(thumbnail) {
                    thumbnail.isSelected( false );
                });
                _.each(self.images(), function(image) {
                    image.hidden( true );
                });
                _.each(self.videos(), function(video) {
                    video.isSelected( false );
                });
                media.isSelected( true );
                self.setCurrentVideo(media, "#bcVideoPlayerWrapper-Modal");
            }
        };

        self.startSlideshow = function () {
            var $slideShow = $( ".bdc-product-slideshow:first" );
            var $slideShowThumbnails = $( ".bdc-product-slideshow-thumbnails" );
            var imagesCount = $( ".bdc-product-slideshow>div" ).length;
            var asNavFor = $slideShowThumbnails.length == 0 ? null : ".bdc-product-slideshow-thumbnails";

            if ( imagesCount > 1 ) {
                if ( $slideShow.length > 0 ) {
                    $slideShow.slick( {
                        lazyLoad: "ondemand",
                        slidesToShow: 1,
                        slidesToScroll: 1,
                        arrows: false,
                        dots: true,
                        asNavFor: asNavFor
                    } );
                }

                if ( $slideShowThumbnails.length > 0 ) {
                    $slideShowThumbnails.slick( {
                        arrows: false,
                        slidesToShow: ( imagesCount >= 4 ) ? 4 : imagesCount,
                        slidesToScroll: 1,
                        asNavFor: ".bdc-product-slideshow:first",
                        focusOnSelect: true
                    } ).init( function () {
                        // Focus on slideshow so the user can use keys to navigate.
                        $( "div.slick-list.draggable:last" ).focus();
                    } ).on( "beforeChange", function ( event, slick, currentSlide, nextSlide ) {
                    } );

                    $( ".bdc-product-slideshow-thumbnails div[data-slick-index=0]" ).addClass( "bdc-product-slideshow-thumbnails-active" );
                    $slideShow.on( "beforeChange", function ( event, slick, currentSlide, nextSlide ) {
                        $( ".bdc-product-slideshow-thumbnails div[data-slick-index='" + currentSlide + "']" ).removeClass( "bdc-product-slideshow-thumbnails-active" );
                        $( ".bdc-product-slideshow-thumbnails div[data-slick-index='" + nextSlide + "']" ).addClass( "bdc-product-slideshow-thumbnails-active" );
                    } );
                }
            }

            $( ".bdc-product-slideshow:first figcaption" ).show();
        };

        self.filterThumbnails = function ( viewModel, event ) {
            var selectedTab = event.target.id.substr( event.target.id.lastIndexOf( "-" ) + 1 );
            if ( selectedTab == "all" ) {
                $( "#gcc-product-gallery-detail-type li" ).show();
            } else if ( selectedTab == "photos" ) {
                $( ".gcc-product-gallery-detail-thumbnails-photo" ).show();
                $( ".gcc-product-gallery-detail-thumbnails-video" ).hide();
            } else if ( selectedTab == "videos" ) {
                $( ".gcc-product-gallery-detail-thumbnails-video" ).show();
                $( ".gcc-product-gallery-detail-thumbnails-photo" ).hide();
            }
            return true;
        };

        self.changeImage = function ( thumbnail ) {
            if ( !thumbnail ) {
                thumbnail = self.thumbnails()[0];
            }

            for ( var i = 0; i < self.thumbnails().length; i++ ) {
                self.thumbnails()[i].isSelected( false );
            }
            for ( var i = 0; i < self.videos().length; i++ ) {
                self.videos()[i].isSelected( false );
            }
            thumbnail.isSelected( true );

            var images = self.images;
            var findVisibleImage = function ( currentImage ) {
                return !currentImage.hidden();
            };
            var visibleImage = _.find( images(), findVisibleImage );

            if ( visibleImage !== undefined ) {
                if ( visibleImage.id === thumbnail.id ) return;
                visibleImage.hidden( true );
            }

            var findMatchingImage = function ( currentImage ) {
                return currentImage.id === thumbnail.id;
            };
            var image = _.find( images(), findMatchingImage );
            if ( image === undefined ) {
                image = new ImageModel( thumbnail.imageUrl + "?quality=90&mode=crop&anchor=middlecenter&width=565&height=565&format=jpg", thumbnail.id, thumbnail.mediaId, thumbnail.altText, thumbnail.caption() );
                images.push( image );
            }
            image.hidden( false );
        };

        self.changeImageById = function ( thumbnailId ) {
            var thumb = _.find( self.thumbnails(), function ( currentThumbnail ) {
                return currentThumbnail.id === thumbnailId;
            } );

            self.changeImage( thumb );
        };

        // This function is specific to the primary gallery.
        self.showVideo = function (video, shouldAutoPlay) {
        if (video.isSelected()) return;
          if (globals.ssm.getState("mobile").active && $($(".bdc-product-slideshow")[2] ).slick("slickCurrentSlide") == 0) {
            var $mobileVideoSlideshow = $( $(".bdc-product-slideshow")[2]);
            $mobileVideoSlideshow.slick("slickGoTo", 0);
            $("#bdc-product-mobile-video-slideshow .slick-dots li:first-child").trigger("click");
          }
          for (var i = 0; i < self.videos().length; i++) {
            self.videos()[i].isSelected(false);
          }
          video.isSelected( true );
          self.setCurrentVideo(video, "#bcVideoPlayerWrapper-Gallery");
          return true;
        };

        self.setCurrentVideo = function (video, elementSelector) {
            self.clearCurrentVideo(elementSelector);
            var durationAsTime = new Date(video.duration).toLocaleTimeString([], { minute: '2-digit', second: '2-digit' });
            $(".bdc-current-video-caption span").text(video.name);
            $(".bdc-current-video-caption small").text(durationAsTime);

            brightcovePlayerLoader({
              refNode: elementSelector,
              videoId: video.id,
              accountId:self.videoAccountId,
              playerId:self.videoPlayerId,
              embedId:"default",
              onSuccess: function(success) {
                  var player = success.ref;
                  var playerElement = player.playerElIngest_;
                  playerElement.classList.add("vjs-fill");
                  self.currGalleryVideoPlayer[elementSelector] = player;
                  player.one('play', () => self.sendVideoEventAnalytics("video start", video.id)); // Recomended in docs instead of first play event
                  player.on('ended', () => self.sendVideoEventAnalytics("video complete", video.id));
              }
            });
        };

        self.clearCurrentVideo = function (elementSelector) {
            var galleryPlayer = $(elementSelector);
            galleryPlayer.empty();
            console.log(self.currGalleryVideoPlayer, self.currGalleryVideoPlayer[elementSelector]);
            if (self.currGalleryVideoPlayer[elementSelector]) {
                self.currGalleryVideoPlayer[elementSelector].dispose();
                self.currGalleryVideoPlayer[elementSelector] = null;
            }
        };

        self.sendVideoEventAnalytics = function (eventName, videoId) {
            var thdAnalyticsEvent = {
                "category": {"primaryCategory": "button submission"},
                "eventInfo": {"eventName": eventName},
                "video": {
                    "id": videoId,
                    "type": digitalData.page.pageInfo.pageType}
                };
            if (window.ddoEventInit) window.ddoEventInit(thdAnalyticsEvent);
            else console.log('Could not send analytics event.', thdAnalyticsEvent)
        }

        self.init = function () {
            // Get Videos from Live Clicker
            self.brightCove.getVideosByProductId( globals.productId ).then( function (videos) {
                _.each(videos, function ( video ) {
                    video.isSelected = ko.observable( false );
                    self.videos.push( video );
                } );

                ko.applyBindings( self, $( ".gcc-product-gallery-type-videos-content")[0]);

                if ( globals.ssm.getState( "mobile" ).active ) {
                    if ( videos && videos.length > 0 ) {

                        var $mobileVideoSlideshow = $( $( ".bdc-product-slideshow" )[2] );

                        $mobileVideoSlideshow.on( "afterChange", function ( event, slick, currentSlide, nextSlide ) {
                            // Pause all videos
                            if (window.videojs) {
                                var players = window.videojs.getAllPlayers();
                                _.each(players, function ( player ) { player.pause(); } );
                            }
                            // Make sure current slide has a video to show.
                            var currentVideoContainer = $( event.target ).find( ".slick-active" ).find( ".bdc-product-mobile-video-container" )[0];
                            var video = videos[currentSlide];
                            // Check if video is injected yet
                            if ($(currentVideoContainer).find("video-js").length == 0) {
                                // Add if needed
                                brightcovePlayerLoader({
                                    refNode: currentVideoContainer,
                                    videoId: video.id,
                                    accountId:self.videoAccountId,
                                    playerId:self.videoPlayerId,
                                    embedId:"default",
                                    onSuccess: function(success) {
                                        var player = success.ref;
                                        var playerElement = player.playerElIngest_;
                                        playerElement.classList.add("vjs-fill");
                                        player.one('play', () => self.sendVideoEventAnalytics("video start", video.id)); // Recomended in docs instead of first play event
                                        player.on('ended', () => self.sendVideoEventAnalytics("video complete", video.id));
                                    }
                                });
                            }
                        } );

                        $mobileVideoSlideshow.slick( {
                            slidesToShow: 1,
                            slidesToScroll: 1,
                            arrows: false,
                            dots: true
                        } );
                    }
                }
            } );
        };

        if (globals.siteId !== 11) {
            self.init();
        }
    };

    return ProductGalleryViewModel;
} );
